import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import store from '../store/index.js'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/products',
    name: 'Products',
    component: () => import('../views/Products.vue'),
    meta: { title: 'Products' }
  },
  {
    path: '/product/:name',
    name: 'Product',
    component: () => import('../views/Product.vue'),
    meta: { title: 'View Product' }
  },
  {
    path: '/cart',
    name: 'Cart',
    component: () => import('../views/Cart.vue'),
    meta: { title: 'My Cart' }
  },
  {
    path: '/request-quotation',
    name: 'Quotation',
    component: () => import('../views/Quotation.vue'),
    meta: { title: 'Request Quotation' }
  },
  {
    path: "/:catchAll(.*)",
    component: () => import('../views/NotFound.vue'),
    meta: { title: 'Page Not Found' }
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  window.document.title = to.meta && to.meta.title ? 'TAT SING TRADING GROUP INC ' + to.meta.title : 'TAT SING TRADING GROUP INC';
  store.commit('isLoading')
  next();
})

router.afterEach(() => {
  store.commit('isFinishedLoading')
})

export default router
